import React from "react"

import CircleImage from "../circle-image/circle-image"

const SubHead = props => {
  return (
    <article className="sub-head">
      <div className="container">
        <CircleImage className="fade-in-delay-2" />

        <h3 className="fade-in-delay-3">
          I work closely with visual designers, user experience designers and
          marketing teams to bring designs to life using HTML, CSS, and
          JavaScript.
        </h3>
      </div>
    </article>
  )
}

export default SubHead
